import { StorageKey } from '@quirion/utils';

import { DEFAULT_API_ENDPOINTS } from '../constants/endpoints';

export function getEndpointsDefinition() {
  const parsed = JSON.parse(localStorage.getItem(StorageKey.Endpoints) ?? '{}');
  if (Object.keys(parsed)?.length) return parsed;
  return DEFAULT_API_ENDPOINTS;
}
